import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ModalData = {
  type: string;
  text: string;
  email?: string;
  phone?: string;
  buttonText: string;
  buttonAction: () => void;
};

/**
 * Service for managing modal states and data. It provides observables to subscribe to for open and close actions,
 * and methods to manipulate the modal state and content dynamically.
 */
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private _openModalData = new BehaviorSubject<ModalData>({
    type: 'app',
    text: '',
    buttonText: '',
    buttonAction: () => {},
  });
  private _closeModalData = new BehaviorSubject(null);

  public openModalData$ = this._openModalData.asObservable();
  public closeModalData$ = this._closeModalData.asObservable();

  /**
   * Opens the modal with the provided configuration.
   * @param config - The configuration object for the modal containing text, button text, and action.
   */
  public openModal = (config: ModalData) => {
    this._openModalData.next(config);
  };

  /**
   * Closes the modal and resets any modal data.
   */
  public closeModal = () => {
    this._closeModalData.next(null);
  };

  /**
   * Updates the current modal's button action.
   * @param buttonAction - A callback function to set as the modal button's action.
   */
  public setModalClickAction = (buttonAction: () => any) => {
    const currentData = this._openModalData.getValue();
    this._openModalData.next({ ...currentData, buttonAction });
  };
}
